module.exports = __webpack_public_path__ + "img/section-organization.3b7a1513.png";